/**
 * PDF.js Configuration
 * Configures the PDF.js worker for PDF parsing and rendering
 */
import { pdfjs } from 'react-pdf';

// Configure PDF.js worker
if (typeof window !== 'undefined') {
  // Use the version from react-pdf's internal pdfjs-dist to ensure exact match
  // react-pdf@10.2.0 uses pdfjs-dist@5.4.296 internally
  const pdfjsVersion = pdfjs.version || '5.4.296';
  
  // Use unpkg CDN (more reliable than cdnjs)
  // Format: https://unpkg.com/pdfjs-dist@VERSION/build/pdf.worker.min.mjs
  pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjsVersion}/build/pdf.worker.min.mjs`;
  
  console.log('📄 PDF.js worker configured:', {
    version: pdfjsVersion,
    workerSrc: pdfjs.GlobalWorkerOptions.workerSrc,
    apiVersion: pdfjs.version
  });
}

export const PDF_CONFIG = {
  // PDF rendering options
  scale: 1.5, // Adjust for better text clarity
  renderTextLayer: true, // Enable text selection
  renderAnnotationLayer: true, // Enable annotations
  // Use version 5.4.296 to match react-pdf's internal pdfjs-dist version
  cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@5.4.296/cmaps/',
  cMapPacked: true,
};

